export const SHOW_MORE_INGREDIENTS_TRACKING = 'show_more_ingredients';
export const SHOW_MORE_NOTICES_TRACKING = 'show_more_notices';
export const PD_NUTRITION_TABLE_ID = 'pd-nutrition-table';

export const productCodesForSeoTest = [
  'MAYWTPW_KEYS16',
  'AGRTYNW_AEDP10',
  'AVOATWW_AEDP10',
  'ARDMAGW_KLAS10',
  'LOPST3W_KHST10',
  'SWRGLCW_KCOL03',
  'AVOENIW_AEDT50',
  'VCHDEOW_KDST30',
  'CSXBHAW_KCLT10',
  'LRPCG5W_KBGE10',
  'LORFILW_KFSR20',
  'LRPLLUW_KBOL10',
  'SWRLIVW_KCOL26',
  'NOIBASW_KCLW29',
  'BURWEEM_AEDT10',
  'PAV831D_ZBMM01',
  'URIBACW_KFCR15',
  'BIRPIDW_KDCR05',
  'EDHWOMW_AEDP10',
  'KERCRMW_KSHA10',
  'GILFUSM_KSPZ15',
  'CTETFNW_KEYS10',
  'GILBL3M_KRAZ25',
  'LRPRETW_KFSR01',
  'SOOVESU_KSCR10',
  'CTEPNGW_KEYS19',
  'EUCURRW_KHCR15',
  'DOVORIW_KDSR10',
  'CTEICOW_KLAQ03',
  'RSCNIAW_KFSR10',
  'STVBRDM_KDEO50',
  'WLLILUW_KCOL08',
  'DRMCPLW_KSHA10',
  'LRPROSW_KDCR20',
  'EUCAPIW_KDCR10',
  'WDWWHNH_DCAN20',
  'CULFRGH_DFRP01',
  'LIRTOZW_KMTW20',
  'LCVLURW_KBOL02',
  'EPLPWPD_KSWG06',
  'AZZHOMM_AEDT05',
  'BIRSEPW_KFSR10',
  'GARHFMW_KSHA01',
  'MAYTABW_KMSC05',
  'GEHCLAW_KFLD10',
  'GARCOSW_KCOL02',
  'TRVROMU_DREF02',
  'EUCAQPW_KBOC10',
  'BIRPHKD_KPLT10',
  'BIRPHZW_KSTA10',
  'WLLSPRW_KRGR30',
  'KERCRMW_KCND12',
  'PAV502D_ZBMM01',
  'SWRTFTW_KSTL91',
  'LOREXCW_KCOL05',
  'CATNUMM_AEDP10',
  'GEHMEDW_KLCR25',
  'RMNSSTW_KHST10',
  'OFLSSSW_AEDP20',
  'LORLARW_KDCR10',
  'SYORORW_KCOL10',
  'SWRSEBW_KSHA01',
  'GILBRNW_KORZ10',
  'POCPERW_KMUP16',
  'ROCJSTW_AEDT10',
  'TRSKSMW_KSHA05',
  'ALFREVW_KCOL24',
  'BIRAIEW_KECR10',
  'BIRSARW_KFCR20',
  'GARRECW_KBOL10',
  'AZZWBNM_AEDP20',
  'NIVINTW_KSWG10',
  'SOAOROW_KAOL41',
  'VCHAXCW_KRGR10',
  'GARMIIW_KANT10',
  'PHI451W_KNHL10',
  'NOITRAW_KPCK35',
  'MTXDREW_KSHA10',
  'JLOMGLW_AEDT10',
  'WLP5SMM_KTRM10',
  'OFLFLAM_AEDT25',
  'NEUBRBW_KPEE02',
  'SWOQVIW_KORZ10',
  'SCWIVIW_KCOLPL',
  'EUCDCAW_KSHA10',
  'ORBSUFW_KTFL10',
  'EUCDCAW_KSHA20',
  'AVOCBCW_KCLG27',
  'UALOPUW_KRGR02',
  'BIRCOTW_KMUP11',
  'GILBRSW_KORZ10',
  'URIBACW_KFCR41',
  'LORTR5W_KCND10',
  'VCHD3DW_KMUP15',
  'ERSMANW_KSCS18',
  'GILGM3M_KSPZ36',
  'SWOMANW_KKOV14',
  'PARULVM_AEDT10',
  'CAUVNGW_KMSK08',
];
